import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای تخصیص ایستگاه و دستگاه

این بخش برای مدیریت تخصیص روزانه یا دوره‌ایِ اپراتورها به ایستگاه‌های کاری (Work Centers) یا دستگاه‌ها و ماشین‌آلات (Machines) در نظر گرفته شده است.

## ۱. ثبت تخصیص جدید
شما می‌توانید مشخص کنید هر اپراتور در کدام ایستگاه/دستگاه فعالیت می‌کند. در کادر «تخصیص دوره‌ای جدید»:

- **اپراتور:** فرد مورد نظر را از لیست انتخاب کنید.
- **حالت تخصیص:** یکی از حالت‌های انحصاری (فرد کل شیفت روی یک ایستگاه است)، هم‌زمان (شخص هم‌زمان دو یا چند دستگاه را اداره می‌کند) یا چرخشی (فرد در طول شیفت بین چند ایستگاه جابجا می‌شود) را مشخص نمایید.
- **ایستگاه کاری / دستگاه:** باید دقیقاً یکی از این دو مورد را انتخاب کنید. یا مشخص می‌کنید اپراتور متعلق به ایستگاه X است، یا مستقیماً پای دستگاه Y می‌ایستد.
- **تاریخ شروع:** روزی که این قانون اعمال می‌شود را وارد کنید.

## ۲. افزودن اسلات چرخشی
چنانچه در مرحله قبل حالت «چرخشی (Rotational)» را انتخاب کرده باشید، می‌توانید برنامه جابه‌جایی شخص را طی ساعات مختلف شیفت تعریف کنید.

- تخصیص چرخش مبدأ (تخصیص مرجع) که در مرحله قبل ساخته‌اید را انتخاب کنید.
- ترتیب جابجایی (مثلاً ۱، ۲، ۳) را مشخص کنید.
- ساعت شروع و پایانِ هر اسلات را نسبت به ابتدای شیفت وارد کنید (مثلاً از ساعت ۰ تا ساعت ۴ شیفت روی دستگاه A، از ساعت ۴ تا ساعت ۸ روی دستگاه B).

## ۳. استعلام وضعیت فعال
با استفاده از بخش پایین صفحه، می‌توانید با وارد کردن نام اپراتور و تاریخ مورد نظر، از سیستم بپرسید که طبق آخرین تخصیص‌های ثبت شده (با لحاظ کردن شیفت‌های چرخشی یا هم‌زمان)، اپراتور در آن روز دقیقاً مسئول کدام ماشین یا ایستگاه است.


export default Layout;
